import {
  MAutocomplete,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { PROCESS_OPTIONS_VALUE } from "@app/pages/background/utils/constans";
import { useInstallation } from "@services/servicesGenericsTables";
import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";

export const fixedInstallation = [
  { id: Math.random(), codigo: "E" },
  { id: Math.random(), codigo: "C" },
  { id: Math.random(), codigo: "F" },
  { id: Math.random(), codigo: "R" },
];

const medium_filters = ["M", "C"];
const process_types = [PROCESS_OPTIONS_VALUE.ALFA, PROCESS_OPTIONS_VALUE.BETA];

const CodigosFondoForm = () => {
  const { getValues } = useFormContext();
  const { installationList } = useInstallation();

  const addCodigosToInstallation = useMemo(() => {
    return [...installationList, ...fixedInstallation];
  }, [installationList]);

  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MAutocomplete
          key={"proceso"}
          name={"proceso"}
          label={"Proceso"}
          options={process_types}
          validation={{ required: `El campo proceso es requerido` }}
        />
        <MAutocomplete
          key={JSON.stringify(getValues("tipo_codigo"))}
          name="tipo_codigo"
          options={addCodigosToInstallation}
          label="Tipo código"
          getOptionLabel={(option) => `${option.codigo}`}
          validation={{ required: "El tipo de código es requerida" }}
        />
        <MAutocomplete
          key={"medio_filtro"}
          name={"medio_filtro"}
          label={"Filtro"}
          options={medium_filters}
        />
        <MTextField
          key={"descripcion"}
          name={"descripcion"}
          label={"Descripcion"}
          type="text"
          fullWidth
          validation={{ required: `El campo descripcion es requerido` }}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default CodigosFondoForm;
